export default __webpack_public_path__ + "static/media/icon-close-filled.12e6378a.svg";